/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { FairAppRequest } from '../models/fair-app-request';
import { KontaktDetail } from '../models/kontakt-detail';
import { KontaktDetailUpdate } from '../models/kontakt-detail-update';
@Injectable({
  providedIn: 'root',
})
class KontaktService extends __BaseService {
  static readonly kontaktCreatePath = '/kontakt/';
  static readonly kontaktSaveCreatePath = '/kontakt/save';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param data undefined
   */
  kontaktCreateResponse(data: FairAppRequest): __Observable<__StrictHttpResponse<FairAppRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/kontakt/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FairAppRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  kontaktCreate(data: FairAppRequest): __Observable<FairAppRequest> {
    return this.kontaktCreateResponse(data).pipe(
      __map(_r => _r.body as FairAppRequest)
    );
  }

  /**
   * @param data undefined
   */
  kontaktSaveCreateResponse(data: KontaktDetailUpdate): __Observable<__StrictHttpResponse<KontaktDetail>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/kontakt/save`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KontaktDetail>;
      })
    );
  }
  /**
   * @param data undefined
   */
  kontaktSaveCreate(data: KontaktDetailUpdate): __Observable<KontaktDetail> {
    return this.kontaktSaveCreateResponse(data).pipe(
      __map(_r => _r.body as KontaktDetail)
    );
  }
}

module KontaktService {
}

export { KontaktService }
